import React from "react";
import Modal from "../modal/modal";
import { HeaderModalProps } from "../@types/header-modal";
import { BodyContainer, HeaderContainer, HeaderModalContainer } from "./header-modal.styled";
import { Text } from "../text/text";
import { Button } from "../button/button";
import { RiCloseFill } from "react-icons/ri";


const HeaderModal: React.FC<HeaderModalProps> = ({ 
    children,
    title, 
    onClose, 
    showCloseButton = true,
    headerTextColor,
    headerColor,
    headerLineColor,
    ...props
}) => {
    return (
        <Modal {...props}>
            <HeaderModalContainer>
                <HeaderContainer>
                    {title && (
                        <Text 
                            fontSize={16}
                            fontWeight={600}
                        >
                            {title}
                        </Text>
                    )}
                    {showCloseButton && (
                        <Button 
                            textColor="#fff" 
                            backgroundColor="transparent" 
                            width="fit-content"
                            padding="0"
                            onClick={onClose}
                        >
                            <RiCloseFill size={22} />
                        </Button>
                    )}	
                </HeaderContainer>
                <BodyContainer>
                    {children}
                </BodyContainer>
            </HeaderModalContainer>
        </Modal>
    );
};

export default HeaderModal;
